import styled from "styled-components";

export const StyledBannerSlide = styled.img`
    width: 100%;
    height: 100%;
    cursor: ${(props) => (props.includeUrl ? "pointer" : "unset")};
`;
